$(function() {
    // Masonry layout

    if ($('#grid').length > 0) {
        $('#grid').masonry({
            itemSelector: '.row',
            columnWidth: '.sizer',
            percentPosition: true
        });
    }
});